<mat-button-toggle
  (click)="toggleInspectMode({ source: 'button' })"
  [checked]="inspectMode$ | async"
  [matTooltip]="toggleInspectModeTooltip"
  class="toolbar-button"
>
  <mat-icon [h3CustomIcon]="inspectModeIcon"></mat-icon>
</mat-button-toggle>
